// CD-5587: the YouTube video is gone (its uploader closed their account) — hidden until Marketing provides a new link.
// import React, { useState } from 'react';
// import CookieHelper from '../../Helpers/cookieHelper';

function MissionVideo() {
  // const [show] = useState(() => CookieHelper.getCookie('videos', 'true') === 'true');
  // if (!show) return null;
  // return (
  //   <div className="video-card">
  //     <div className="video-head">
  //       <span className="vh-ic"><i className="fa-solid fa-circle-play" /></span>
  //       <h3>BARE International mission &amp; values</h3>
  //       <span className="vh-by">Respect for diversity</span>
  //     </div>
  //     <div className="video-frame">
  //       <iframe
  //         title="BARE International mission and values"
  //         src="https://www.youtube.com/embed/BZZWiGbv5w4?si=uU-Q61bOdkImNX4u&rel=0"
  //         frameBorder="0"
  //         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  //         allowFullScreen
  //       />
  //     </div>
  //   </div>
  // );
  return null;
}

export default MissionVideo;
